import * as yup from "yup";

const validationSchema = yup.object().shape({
  terms_conditions: yup
    .bool()
    .required("Terms and Conditions field is required"),
});

export default validationSchema;
